export default "__VITE_ASSET__QHcY9TIK__"